import { render } from "./OnDemandIncludedThemes.vue?vue&type=template&id=50dc17c4&scoped=true"
import script from "./OnDemandIncludedThemes.vue?vue&type=script&lang=js"
export * from "./OnDemandIncludedThemes.vue?vue&type=script&lang=js"

import "./OnDemandIncludedThemes.vue?vue&type=style&index=0&id=50dc17c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50dc17c4"]])

export default __exports__